<section class="profile">
    <div class="container">
        <form [formGroup]="profileForm" (ngSubmit)="update()" #proForm="ngForm">

            <div class="row profile-card">

                <!-- LEFT: IMAGE -->
                <div class="col-lg-3 text-center">
                    <div class="profile-img">
                        <img [src]="propertyImages[0]" alt="Profile" />

                        <label class="upload-btn">
                            Change Photo
                            <input type="file" name="file" #imageInput accept="image/png, image/gif, image/jpeg"
                                (change)="uploadAws($event)" formControlName="images" />
                        </label>
                    </div>
                </div>

                <!-- RIGHT: FORM -->
                <div class="col-lg-9">
                    <div class="row">

                        <div class="col-md-6 mb-3">
                            <label>First Name</label>
                            <input type="text" class="form-control" formControlName="firstName">
                        </div>

                        <div class="col-md-6 mb-3">
                            <label>Last Name</label>
                            <input type="text" class="form-control" formControlName="lastName">
                        </div>

                        <div class="col-md-6 mb-3">
                            <label>Email ID</label>
                            <input type="email" class="form-control" formControlName="email">
                        </div>

                        <div class="col-md-6 mb-3">
                            <label>Mobile Number</label>
                            <ngx-intl-tel-input [cssClass]="'form-control'" [onlyCountries]="onlyCountries"
                                [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="false"
                                [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
                                style="width: 100%;" [phoneValidation]="true" [separateDialCode]="true" id="mobile"
                                [selectedCountryISO]="selectedISOCountry" name="mobile" formControlName="mobile"
                                aria-readonly="true">
                            </ngx-intl-tel-input>

                        </div>

                        <div class="col-12 text-end">
                            <button type="submit" class="profile-edit-btn">Update</button>
                        </div>

                    </div>
                </div>

            </div>

        </form>
    </div>
</section>